import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
import { DashboardConstants } from '../../actions/constant';
const {
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
} = DashboardConstants;

function* getAllSubmittedDocumentOfCSVDashboard(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER });
    const response = yield call(dashboardServices.getDashboardCsvDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE, payload: error });
  }
}

function* dashboardDocumentListCsvSaga() {
  yield takeEvery(
    GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
    getAllSubmittedDocumentOfCSVDashboard
  );
}

export default dashboardDocumentListCsvSaga;
